/* biberna Geschenkfinder - gebaut aus Git/biberna-geschenkfinder (build/baue-theme.cjs), nicht von Hand aendern */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.bibernaGeschenkEngine = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var MAX_DESIGNS = 3;
  var MAX_KANDIDATEN = 12;
  var STUFEN = [
    { id: 'basis', titel: 'Bettwäsche' },
    { id: 'laken', titel: '+ Spannbetttuch' },
    { id: 'komplett', titel: 'Komplett-Set' }
  ];
  function eigen(obj, key) {
    return obj && typeof key === 'string' && Object.prototype.hasOwnProperty.call(obj, key) ? obj[key] : undefined;
  }
  function enthaelt(liste, wert) {
    return (liste || []).indexOf(wert) > -1;
  }
  function lieferbar(item, regeln) {
    return item.bestand >= (regeln.mindestBestand || 1);
  }
  function farbKette(farbe, farbErsatz) {
    var ersatz = eigen(farbErsatz && farbErsatz.colorFallback, farbe) || [];
    var neutral = (farbErsatz && farbErsatz.neutralDefault) || [];
    return [farbe].concat(ersatz, neutral);
  }
  function viaVon(fIdx, farbe, farbErsatz) {
    if (fIdx === 0) return 'exakt';
    if (fIdx < 0) return 'nur-groesse';
    var ersatz = eigen(farbErsatz && farbErsatz.colorFallback, farbe) || [];
    return fIdx <= ersatz.length ? 'ersatz' : 'neutral';
  }
  function bestesZubehoer(kandidaten, groessen, farbe, farbErsatz) {
    var kette = farbKette(farbe, farbErsatz);
    var best = null;
    kandidaten.forEach(function (k) {
      var gIdx = groessen.indexOf(k.groesse);
      if (gIdx < 0) return;
      var fIdx = kette.indexOf(k.farbe);
      var rang = (fIdx < 0 ? 50 : fIdx) * 10 + gIdx;
      if (!best || rang < best.rang || (rang === best.rang && k.preis < best.item.preis)) {
        best = { item: k, rang: rang, via: viaVon(fIdx, farbe, farbErsatz) };
      }
    });
    return best;
  }
  function deckenFuer(antworten) {
    if (antworten.fuer === 'kind') return antworten.kindAlter === 'klein' ? '100x135' : '135x200';
    if (antworten.fuer === 'paar' && antworten.paarDecken === 'eine') return '200x200';
    return antworten.decke || '135x200';
  }
  function garniturAnzahl(antworten) {
    return antworten.fuer === 'paar' && antworten.paarDecken !== 'eine' ? 2 : 1;
  }
  function punkte(g, antworten, regeln) {
    var p = 0;
    var farben = antworten.farben || [];
    if (farben.length && !enthaelt(farben, g.fam)) p += 30;
    if (antworten.fuer === 'kind') {
      if (antworten.motiv && g.motiv !== antworten.motiv) p += 20;
    } else if (antworten.stil && g.stil !== antworten.stil) {
      p += 20;
    }
    var vorliebe = eigen(regeln.personenFarben, antworten.fuer);
    if (vorliebe && !farben.length) {
      var idx = vorliebe.indexOf(g.fam);
      p += idx < 0 ? 6 : idx;
    }
    if (antworten.gefuehl === 'warm' && /^08405/.test(g.serie)) p -= 4;
    if (g.szene) p -= 1; // Bettszene vorhanden: zeigt sich schoener
    if (g.bestand < 10) p += 2;
    return p;
  }
  function garnituren(katalog, antworten, regeln, marke) {
    var decke = deckenFuer(antworten);
    var kind = antworten.fuer === 'kind';
    var basis = katalog.filter(function (i) {
      return i.typ === 'garnitur' && i.marke === marke && i.decke === decke &&
        !!i.kind === kind && lieferbar(i, regeln);
    });
    var gelockert = [];
    var pool = basis;
    if (!kind && antworten.gefuehl) {
      var passend = basis.filter(function (i) { return i.gefuehl === antworten.gefuehl; });
      if (passend.length) pool = passend;
      else if (basis.length) gelockert = gelockert.concat('gefuehl');
    }
    var bewertet = pool
      .map(function (g) { return { item: g, punkte: punkte(g, antworten, regeln) }; })
      .sort(function (a, b) { return a.punkte - b.punkte || b.item.bestand - a.item.bestand; });
    var gesehen = {};
    var auswahl = bewertet.filter(function (b) {
      if (gesehen[b.item.h]) return false;
      gesehen[b.item.h] = true;
      return true;
    }).slice(0, MAX_KANDIDATEN);
    var farben = antworten.farben || [];
    if (farben.length && auswahl.length && !auswahl.some(function (b) { return enthaelt(farben, b.item.fam); })) {
      gelockert = gelockert.concat('farbe');
    }
    var stil = kind ? antworten.motiv : antworten.stil;
    if (stil && auswahl.length && !auswahl.some(function (b) { return (kind ? b.item.motiv : b.item.stil) === stil; })) {
      gelockert = gelockert.concat(kind ? 'motiv' : 'stil');
    }
    return { auswahl: auswahl, gelockert: gelockert };
  }
  function lakenGroessen(antworten, regeln) {
    var l = antworten.laken || {};
    var schluessel = antworten.fuer === 'kind' && antworten.kindAlter === 'klein' ? 'kind-klein' : l.matratze;
    return eigen(regeln.lakenGroessen, schluessel) || [];
  }
  function lakenVorzug(g, regeln) {
    var q = regeln.lakenQualitaet || {};
    var keys = Object.keys(q);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (k === 'standard' || k.charAt(0) === '_') continue;
      if (k === 'biber' ? /feinbiber|\bbiber\b/i.test(g.t) : g.serie.indexOf(k) === 0) return q[k];
    }
    return q.standard || [];
  }
  function lakenFuer(katalog, g, antworten, regeln, farbErsatz) {
    var groessen = lakenGroessen(antworten, regeln);
    if (!groessen.length) return null;
    var alle = katalog.filter(function (i) {
      return i.typ === 'laken' && i.marke === g.marke && lieferbar(i, regeln) && groessen.indexOf(i.groesse) > -1;
    });
    var gewaehlt = (antworten.laken || {}).serie;
    if (gewaehlt) {
      var inSerie = alle.filter(function (k) { return k.serie === gewaehlt; });
      if (inSerie.length) return bestesZubehoer(inSerie, groessen, g.farbe, farbErsatz);
    }
    var normal = alle.filter(function (i) { return i.art === 'normal'; });
    var serien = lakenVorzug(g, regeln);
    for (var i = 0; i < serien.length; i++) {
      var treffer = normal.filter(function (k) { return k.serie === serien[i]; });
      if (treffer.length) return bestesZubehoer(treffer, groessen, g.farbe, farbErsatz);
    }
    return bestesZubehoer(normal, groessen, g.farbe, farbErsatz);
  }
  function lakenAuswahl(katalog, g, antworten, regeln) {
    var groessen = lakenGroessen(antworten, regeln);
    if (!g || !groessen.length) return [];
    var gesehen = {};
    return katalog.filter(function (i) {
      if (i.typ !== 'laken' || i.marke !== g.marke || !lieferbar(i, regeln) || groessen.indexOf(i.groesse) < 0) return false;
      if (gesehen[i.serie]) return false;
      gesehen[i.serie] = true;
      return true;
    }).map(function (i) { return { serie: i.serie, titel: i.t }; });
  }
  function kissenGroesse(g, antworten) {
    var gewaehlt = (antworten.kissen || {}).groesse;
    if (gewaehlt) return gewaehlt;
    var m = /\+\s*\d+x\s*(\d{2}x\d{2})\s*cm/.exec(g.groesse || '');
    return m ? m[1] : '80x80';
  }
  function kissenPasst(k, g, regeln) {
    var r = regeln.kissenRegeln || {};
    if (enthaelt(r.fuerAlle, k.serie)) return true;
    var praefix = eigen(r.nurGleicheSerie, k.serie);
    return !!praefix && g.serie.indexOf(praefix) === 0;
  }
  function kissenFuer(katalog, g, antworten, regeln, farbErsatz) {
    if (g.marke !== 'biberna') return null;
    var groessen = eigen(regeln.kissenGroessen, kissenGroesse(g, antworten)) || [];
    var kandidaten = katalog.filter(function (i) {
      return i.typ === 'kissen' && lieferbar(i, regeln) && kissenPasst(i, g, regeln) && groessen.indexOf(i.groesse) > -1;
    });
    var fuerAlle = (regeln.kissenRegeln || {}).fuerAlle;
    var gleicheQualitaet = kandidaten.filter(function (i) { return !enthaelt(fuerAlle, i.serie); });
    return bestesZubehoer(gleicheQualitaet.length ? gleicheQualitaet : kandidaten, groessen, g.farbe, farbErsatz);
  }
  function position(item, menge, via) {
    return { id: item.id, h: item.h, t: item.t, typ: item.typ, farbe: item.farbe, groesse: item.groesse,
      preis: item.preis, menge: menge, via: via || 'exakt', bild: item.bild, szene: item.szene || null };
  }
  function summe(positionen) {
    return positionen.reduce(function (s, p) { return s + p.preis * p.menge; }, 0);
  }
  function imBand(summeCent, stufe, rabatt) {
    var pct = 1 - stufe / summeCent;
    return pct >= rabatt.min - 1e-9 && pct <= rabatt.max + 1e-9 ? pct : null;
  }
  function preisFuer(summeCent, leiter, regeln) {
    var rabatt = regeln.rabatt;
    var rund = regeln.rundeStufen || [];
    var beste = null;
    leiter.forEach(function (p) {
      var pct = imBand(summeCent, p, rabatt);
      if (pct === null) return;
      var wert = Math.abs(pct - rabatt.ziel) - (enthaelt(rund, p) ? 0.005 : 0);
      if (!beste || wert < beste.wert) beste = { preis: p, pct: pct, wert: wert };
    });
    return beste;
  }
  function setAus(positionen, leiter, regeln) {
    var einzeln = summe(positionen);
    var p = preisFuer(einzeln, leiter, regeln);
    if (!p) return null;
    return { positionen: positionen, einzeln: einzeln, preis: p.preis, ersparnis: einzeln - p.preis, pct: p.pct };
  }
  function lakenMenge(antworten) {
    var l = antworten.laken || {};
    return antworten.fuer === 'paar' && l.matratze !== '180-200' ? 2 : 1;
  }
  function kissenMenge(k) {
    return /^2x/.test(k.item.groesse) ? 1 : 2;
  }
  function stufenFuer(g, katalog, antworten, regeln, farbErsatz, leiter) {
    var garnitur = position(g, garniturAnzahl(antworten), 'exakt');
    var laken = lakenFuer(katalog, g, antworten, regeln, farbErsatz);
    var kissen = kissenFuer(katalog, g, antworten, regeln, farbErsatz);
    var lakenPos = laken ? [position(laken.item, lakenMenge(antworten), laken.via)] : [];
    var kissenPos = kissen ? [position(kissen.item, kissenMenge(kissen), kissen.via)] : [];
    var inhalte = {
      basis: [garnitur],
      laken: laken ? [garnitur].concat(lakenPos) : null,
      komplett: kissen ? [garnitur].concat(lakenPos, kissenPos) : null
    };
    return STUFEN.map(function (s) {
      var set = inhalte[s.id] ? setAus(inhalte[s.id], leiter, regeln) : null;
      return set ? Object.assign({ stufe: s.id, titel: s.titel }, set) : null;
    }).filter(Boolean);
  }
  function verschiedeneFarben(designs, max) {
    var farben = [];
    var erste = designs.filter(function (d) {
      if (farben.indexOf(d.garnitur.farbe) > -1) return false;
      farben.push(d.garnitur.farbe);
      return true;
    }).slice(0, max);
    return erste.concat(designs.filter(function (d) { return erste.indexOf(d) < 0; })).slice(0, max);
  }
  function farbAuswahl(katalog, g, regeln) {
    var gesehen = {};
    return katalog.filter(function (i) {
      if (i.typ !== 'garnitur' || i.h !== g.h || i.groesse !== g.groesse || !lieferbar(i, regeln)) return false;
      if (gesehen[i.farbe]) return false;
      gesehen[i.farbe] = true;
      return true;
    }).map(function (i) { return { id: i.id, farbe: i.farbe }; });
  }
  function mitFarbwahl(katalog, g, antworten, regeln) {
    var id = eigen(antworten.farbwahl, g.h);
    if (!id || id === g.id) return g;
    var treffer = katalog.filter(function (i) {
      return i.id === id && i.typ === 'garnitur' && i.h === g.h && i.groesse === g.groesse && lieferbar(i, regeln);
    })[0];
    return treffer || g;
  }
  function angebot(katalog, antworten, regeln, farbErsatz) {
    var leiter = eigen(regeln.stufenJePerson, antworten.fuer) || regeln.stufen;
    var wahl = garnituren(katalog, antworten, regeln, 'biberna');
    var designs = wahl.auswahl.map(function (g, i) {
      return { garnitur: g.item, rang: i, stufen: stufenFuer(g.item, katalog, antworten, regeln, farbErsatz, leiter) };
    }).filter(function (d) { return d.stufen.length; })
      .sort(function (a, b) { return b.stufen.length - a.stufen.length || a.rang - b.rang; });
    designs = verschiedeneFarben(designs, MAX_DESIGNS).map(function (d) {
      var g = mitFarbwahl(katalog, d.garnitur, antworten, regeln);
      var stufen = g === d.garnitur ? d.stufen : stufenFuer(g, katalog, antworten, regeln, farbErsatz, leiter);
      return stufen.length ? { garnitur: g, stufen: stufen } : { garnitur: d.garnitur, stufen: d.stufen };
    });
    return {
      designs: designs,
      castell: castellAngebot(katalog, antworten, regeln, farbErsatz),
      gelockert: wahl.gelockert,
      leer: !designs.length
    };
  }
  function castellAngebot(katalog, antworten, regeln, farbErsatz) {
    var c = regeln.castell || {};
    if (antworten.fuer === 'kind' || antworten.fuer === 'paar') return null;
    if (!enthaelt(c.deckenGroessen, deckenFuer(antworten))) return null;
    var leiter = (regeln.stufen || []).filter(function (p) { return p <= c.stufe; });
    var ohneGefuehl = Object.assign({}, antworten, { gefuehl: null });
    var wahl = garnituren(katalog, ohneGefuehl, regeln, 'castell');
    for (var i = 0; i < wahl.auswahl.length; i++) {
      var stufen = stufenFuer(mitFarbwahl(katalog, wahl.auswahl[i].item, antworten, regeln), katalog, antworten, regeln, farbErsatz, leiter)
        .filter(function (s) { return s.stufe !== 'komplett'; });
      if (stufen.length) return stufen[stufen.length - 1];
    }
    return null;
  }
  function pruefeSet(katalog, antworten, regeln, farbErsatz, eingereicht) {
    if (!eingereicht || !Array.isArray(eingereicht.positionen)) return null;
    var schluessel = function (positionen) {
      return positionen.map(function (p) { return p.id + 'x' + p.menge; }).sort().join(',');
    };
    var soll = schluessel(eingereicht.positionen);
    var a = angebot(katalog, antworten, regeln, farbErsatz);
    var alle = a.designs.reduce(function (acc, d) { return acc.concat(d.stufen); }, []);
    if (a.castell) alle = alle.concat(a.castell);
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].preis === eingereicht.preis && schluessel(alle[i].positionen) === soll) return alle[i];
    }
    return null;
  }
  return {
    STUFEN: STUFEN,
    pruefeSet: pruefeSet,
    angebot: angebot,
    lakenAuswahl: lakenAuswahl,
    farbAuswahl: farbAuswahl,
    _intern: { garnituren: garnituren, lakenFuer: lakenFuer, kissenFuer: kissenFuer, kissenGroesse: kissenGroesse, preisFuer: preisFuer, deckenFuer: deckenFuer }
  };
}));
;
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.bibernaGeschenkSchritte = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  var FARBEN = [
    { wert: 'weiss_natur', titel: 'Weiß & Natur', toene: ['#ffffff', '#efe8dc', '#e6dccb'] },
    { wert: 'grau', titel: 'Grau', toene: ['#c9c9c9', '#8f9296', '#55585c'] },
    { wert: 'blau', titel: 'Blau', toene: ['#cfe0ee', '#7d9cbc', '#2f4a6b'] },
    { wert: 'gruen', titel: 'Grün', toene: ['#d5e3c8', '#9bb38a', '#4e6b4a'] },
    { wert: 'rose_rot', titel: 'Rosé & Rot', toene: ['#f1d4d6', '#c98b93', '#8c2a3b'] },
    { wert: 'erd', titel: 'Erdtöne', toene: ['#e3d3bc', '#b39572', '#7a5a3e'] }
  ];
  var MATRATZEN = [
    { wert: '90-100', titel: '90–100 × 200' },
    { wert: '140-160', titel: '140–160 × 200' },
    { wert: '180-200', titel: '180–200 × 200' },
    { wert: '', titel: 'Weiß ich nicht', text: 'Dann ohne Spannbetttuch', schluessel: 'unbekannt' }
  ];
  var SCHRITTE = [
    {
      id: 'fuer',
      kurz: 'Person',
      frage: 'Für wen ist das Geschenk?',
      felder: [{ name: 'fuer', optionen: [
        { wert: 'frau', titel: 'Für eine Frau', icon: 'frau' },
        { wert: 'mann', titel: 'Für einen Mann', icon: 'mann' },
        { wert: 'paar', titel: 'Für ein Paar', text: 'Doppelbett', icon: 'paar' },
        { wert: 'kind', titel: 'Für ein Kind', icon: 'kind' },
        { wert: 'selbst', titel: 'Für mich selbst', icon: 'selbst' }
      ] }]
    },
    {
      id: 'groesse',
      kurz: 'Größe',
      frage: 'Welche Größe hat die Bettdecke?',
      hinweis: 'Unsicher? 135 × 200 cm ist die Standardgröße in Deutschland.',
      felder: function (a) {
        var matratze = { name: 'matratze', titel: 'Und die Matratze? (für das Spannbetttuch)', optionen: MATRATZEN };
        if (a.fuer === 'kind') {
          var alter = { name: 'kindAlter', optionen: [
            { wert: 'klein', titel: 'Kleinkind', text: 'Decke 100 × 135 cm', bild: { typ: 'garnitur', kind: true, decke: '100x135' } },
            { wert: 'schul', titel: 'Schulkind', text: 'Decke 135 × 200 cm', bild: { typ: 'garnitur', kind: true, decke: '135x200' } }
          ] };
          return a.kindAlter === 'schul' ? [alter, matratze] : [alter];
        }
        var decken = { name: 'decke', optionen: [
          { wert: '135x200', titel: '135 × 200 cm', text: 'Standard' },
          { wert: '155x200', titel: '155 × 200 cm', text: 'Komfort' },
          { wert: '155x220', titel: '155 × 220 cm', text: 'Komfort, extra lang' },
          { wert: '135x200', titel: 'Weiß ich nicht', text: 'Wir nehmen die Standardgröße', schluessel: 'unbekannt' }
        ] };
        if (a.fuer === 'paar') {
          var anzahl = { name: 'paarDecken', optionen: [
            { wert: 'zwei', titel: 'Zwei einzelne Decken' },
            { wert: 'eine', titel: 'Eine große Decke', text: '200 × 200 cm' }
          ] };
          if (a.paarDecken === 'zwei') return [anzahl, decken, matratze];
          return a.paarDecken === 'eine' ? [anzahl, matratze] : [anzahl];
        }
        return [decken, matratze];
      }
    },
    {
      id: 'gefuehl',
      kurz: 'Stoff',
      optional: true,
      frage: 'Wie soll es sich anfühlen?',
      gilt: function (a) { return a.fuer !== 'kind'; },
      felder: [{ name: 'gefuehl', optionen: [
        { wert: 'warm', titel: 'Kuschelig warm', text: 'Biber, Flanell', bild: { typ: 'garnitur', kind: false, gefuehl: 'warm' } },
        { wert: 'seidig', titel: 'Seidig glatt', text: 'Mako-Satin', bild: { typ: 'garnitur', kind: false, gefuehl: 'seidig' } },
        { wert: 'leicht', titel: 'Leicht & luftig', text: 'Seersucker, Musselin, Tencel', bild: { typ: 'garnitur', kind: false, gefuehl: 'leicht' } }
      ] }]
    },
    {
      id: 'farben',
      kurz: 'Farbe',
      optional: true,
      frage: 'Welche Farben mag die Person?',
      hinweis: 'Bis zu zwei auswählen.',
      gilt: function (a) { return a.fuer !== 'kind'; },
      farben: true
    },
    {
      id: 'stil',
      kurz: 'Stil',
      optional: true,
      frage: 'Welcher Stil gefällt?',
      felder: function (a) {
        if (a.fuer === 'kind') {
          return [{ name: 'motiv', optionen: [
            { wert: 'tiere', titel: 'Tiere', bild: { typ: 'garnitur', kind: true, motiv: 'tiere' } },
            { wert: 'fahrzeuge', titel: 'Fahrzeuge', bild: { typ: 'garnitur', kind: true, motiv: 'fahrzeuge' } },
            { wert: 'sterne', titel: 'Sterne & Weltraum', bild: { typ: 'garnitur', kind: true, motiv: 'sterne' } },
            { wert: 'einhorn', titel: 'Einhorn & Regenbogen', bild: { typ: 'garnitur', kind: true, motiv: 'einhorn' } },
            { wert: '', titel: 'Egal', schluessel: 'egal' }
          ] }];
        }
        return [{ name: 'stil', optionen: [
          { wert: 'uni', titel: 'Uni', text: 'Eine Farbe, ruhig', bild: { typ: 'garnitur', kind: false, stil: 'uni' } },
          { wert: 'dezent', titel: 'Dezent', text: 'Streifen, meliert', bild: { typ: 'garnitur', kind: false, stil: 'dezent' } },
          { wert: 'struktur', titel: 'Struktur', text: 'Seersucker, Musselin', bild: { typ: 'garnitur', kind: false, stil: 'struktur' } },
          { wert: 'motiv', titel: 'Mit Motiv', bild: { typ: 'garnitur', kind: false, stil: 'motiv' } },
          { wert: '', titel: 'Egal', schluessel: 'egal' }
        ] }];
      }
    }
  ];
  var KISSEN = [
    { wert: '80x80', titel: '80 × 80' },
    { wert: '40x80', titel: '40 × 80' },
    { wert: '40x60', titel: '40 × 60' },
    { wert: '40x40', titel: '40 × 40' }
  ];
  function felderVon(schritt, a) {
    return typeof schritt.felder === 'function' ? schritt.felder(a) : (schritt.felder || []);
  }
  function pflichtFertig(a) {
    return aktiveSchritte(a).filter(function (s) { return !s.optional; }).every(function (s) { return fertig(s, a); });
  }
  function aktiveSchritte(a) {
    return SCHRITTE.filter(function (s) { return !s.gilt || s.gilt(a); });
  }
  function fertig(schritt, a) {
    if (schritt.farben) return true;
    return felderVon(schritt, a).every(function (f) {
      if (f.name === 'matratze') return !!(a._wahl && a._wahl.matratze);
      return a[f.name] !== undefined && a[f.name] !== null;
    });
  }
  function vorbelegung(suche) {
    var p;
    try { p = new URLSearchParams(suche || ''); } catch (e) { return null; }
    var fuer = String(p.get('fuer') || '').toLowerCase();
    var erlaubt = SCHRITTE[0].felder[0].optionen.map(function (o) { return o.wert; });
    if (erlaubt.indexOf(fuer) < 0) return null;
    var antwort = { fuer: fuer };
    var alter = String(p.get('alter') || '').toLowerCase();
    if (fuer === 'kind' && (alter === 'klein' || alter === 'schul')) antwort.kindAlter = alter;
    return antwort;
  }
  function mitVorbelegung(grundform, gemerkt, vor) {
    if (!vor) return null;
    if (gemerkt && gemerkt.fuer === vor.fuer && (!vor.kindAlter || gemerkt.kindAlter === vor.kindAlter)) return null;
    var wahl = { fuer: vor.fuer };
    if (vor.kindAlter) wahl.kindAlter = vor.kindAlter;
    var a = Object.assign({}, grundform, vor, { _wahl: wahl });
    var offen = aktiveSchritte(a).filter(function (s) { return !fertig(s, a); })[0];
    return { antworten: a, schritt: offen ? offen.id : 'ergebnis' };
  }
  return {
    SCHRITTE: SCHRITTE,
    FARBEN: FARBEN,
    MATRATZEN: MATRATZEN,
    KISSEN: KISSEN,
    felderVon: felderVon,
    pflichtFertig: pflichtFertig,
    aktiveSchritte: aktiveSchritte,
    fertig: fertig,
    vorbelegung: vorbelegung,
    mitVorbelegung: mitVorbelegung
  };
}));
;
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.bibernaGeschenkErgebnis = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  function esc(s) {
    return String(s === undefined || s === null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function euro(cent) {
    return (cent / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function bildUrl(url, breite) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + breite;
  }
  function kurztitel(t) {
    return String(t || '').replace(/\s*\(\d{7}\)\s*$/, '').replace(/\s+–\s+.*$/, '').replace(/^biberna\s+/i, '');
  }
  function herkunft(serie) {
    if (/^08405/.test(serie || '')) return 'Gewebt in unserer eigenen Weberei in Hamminkeln';
    return '';
  }
  function istBiber(t) {
    return /feinbiber|\bbiber\b/i.test(t || '');
  }
  var LOCKER_TEXTE = {
    farbe: 'In deinen Wunschfarben gibt es gerade kein passendes Set. Wir zeigen dir abgestimmte Töne.',
    stil: 'Im gewünschten Stil ist gerade nichts passend lieferbar. Hier die schönsten Alternativen.',
    motiv: 'Dieses Motiv ist gerade nicht lieferbar. Hier andere Lieblingsmotive.',
    gefuehl: 'In diesem Stoff ist die Größe gerade nicht lieferbar. Wir zeigen dir einen ähnlich angenehmen Stoff.'
  };
  function hinweise(gelockert) {
    return (gelockert || []).map(function (g) {
      return LOCKER_TEXTE[g] ? '<p class="bgf-hinweis">' + esc(LOCKER_TEXTE[g]) + '</p>' : '';
    }).join('');
  }
  function groesseText(g) {
    return String(g || '')
      .replace(/^\d+x\s*/, '')
      .replace(/\s*\+\s*(\d+)x\s*/, function (m, n) { return n === '1' ? ', Kissen ' : ', ' + n + ' Kissen '; })
      .replace(/(\d)x(\d)/g, '$1 × $2')
      .replace(/^(\d)x\s*/, '');
  }
  var TON_TEXTE = { ersatz: '(abgestimmter Ton)', neutral: '(neutraler Ton)', 'nur-groesse': '(Farbe nach Verfügbarkeit)' };
  function stufenWahl(stufen, aktiv) {
    if (stufen.length < 2) return '';
    var mitte = stufen[Math.min(1, stufen.length - 1)].stufe;
    return '<div class="bgf-stufen" role="group" aria-label="Ausstattung">' + stufen.map(function (s) {
      var an = s.stufe === aktiv;
      return '<button type="button" class="bgf-stufe' + (an ? ' is-aktiv' : '') + '" data-stufe="' + esc(s.stufe) + '" aria-pressed="' + an + '">' +
        '<span class="bgf-stufe__titel">' + esc(s.titel) + '</span>' +
        '<span class="bgf-stufe__preis">' + euro(s.preis) + '</span>' +
        '<span class="bgf-stufe__pct">−' + Math.round(s.pct * 100) + ' %</span>' +
        (s.stufe === mitte ? '<span class="bgf-stufe__marke">Beliebteste Wahl</span>' : '') +
        '</button>';
    }).join('') + '</div>';
  }
  function auswahlFeld(attr, typ, wahl, beschriftung) {
    if (!wahl || !wahl.optionen || wahl.optionen.length < 2) return '';
    return '<label class="bgf-tausch"><span class="bgf-unsichtbar">' + esc(beschriftung) + '</span>' +
      '<select ' + attr + '="' + typ + '">' + wahl.optionen.map(function (o) {
        return '<option value="' + esc(o.wert) + '"' + (o.wert === wahl.aktuell ? ' selected' : '') + '>' + esc(o.titel) + '</option>';
      }).join('') + '</select></label>';
  }
  function groessenAuswahl(typ, wahl) {
    return (wahl && wahl.farbe ? auswahlFeld('data-farbe', typ, wahl.farbe, 'Farbe ändern') : '') +
      auswahlFeld('data-groesse', typ, wahl, 'Größe ändern') +
      (wahl && wahl.qualitaet ? auswahlFeld('data-qualitaet', typ, wahl.qualitaet, 'Qualität ändern') : '');
  }
  function artikelKachel(p, serie, wahl) {
    var ton = TON_TEXTE[p.via] ? ' <span class="bgf-klein">' + TON_TEXTE[p.via] + '</span>' : '';
    var h = herkunft(serie);
    return '<li class="bgf-artikel">' +
      '<div class="bgf-artikel__bild">' + (p.bild ? '<img src="' + esc(bildUrl(p.bild, 300)) + '" alt="" width="300" height="300" loading="lazy">' : '') +
        '<span class="bgf-artikel__menge">' + p.menge + '×</span></div>' +
      '<div class="bgf-artikel__text">' +
        '<span class="bgf-artikel__titel">' + esc(kurztitel(p.t)) + '</span>' +
        '<span class="bgf-pos__detail">' + esc(groesseText(p.groesse)) + ' · ' + esc(p.farbe) + ton + '</span>' +
        (h ? '<span class="bgf-pos__herkunft">' + esc(h) + '</span>' : '') +
        groessenAuswahl(p.typ, wahl) +
      '</div>' +
      '<span class="bgf-artikel__preis">' + euro(p.preis * p.menge) + '</span>' +
    '</li>';
  }
  function setKarte(set, katalogNachId, altIndex, altAnzahl, groessenWahl) {
    var g = set.positionen[0];
    var pct = Math.round(set.pct * 100);
    return '<div class="bgf-set">' +
      '<div class="bgf-set__bild">' +
        ((g.szene || g.bild) ? '<img src="' + esc(bildUrl(g.szene || g.bild, 900)) + '" alt="' + esc(kurztitel(g.t) + ' in ' + g.farbe) + '" width="900" height="900" loading="lazy">' : '') +
        '<span class="bgf-plakette"><span>−' + pct + ' %</span><small>Set-Vorteil</small></span>' +
        (altAnzahl > 1 ? '<div class="bgf-set__wechsel">' +
          '<button type="button" class="bgf-pfeil" data-aktion="alt" data-richtung="-1" aria-label="Vorheriges Design">‹</button>' +
          '<span>Design ' + (altIndex + 1) + ' von ' + altAnzahl + '</span>' +
          '<button type="button" class="bgf-pfeil" data-aktion="alt" data-richtung="1" aria-label="Nächstes Design">›</button></div>' : '') +
      '</div>' +
      '<h3 class="bgf-set__titel">Dein Set auf einen Blick</h3>' +
      (set.wechsel ? '<p class="bgf-klein">Mit Wechselgarnitur: eine auf dem Bett, eine im Schrank.</p>' : '') +
      '<ul class="bgf-artikelliste">' + set.positionen.map(function (p) {
        return artikelKachel(p, (katalogNachId[p.id] || {}).serie, (groessenWahl || {})[p.typ]);
      }).join('') + '</ul>' +
      (istBiber(g.t) ? '<p class="bgf-klein">biberna hat die Biber-Bettwäsche 1968 erfunden.</p>' : '') +
      preisBlock(set) +
    '</div>';
  }
  function preisBlock(set) {
    var pct = Math.round(set.pct * 100);
    return '<div class="bgf-preis">' +
      '<div class="bgf-preis__zeile"><span>Einzeln gekauft</span><s>' + euro(set.einzeln) + '</s></div>' +
      '<div class="bgf-preis__zeile bgf-preis__zeile--rabatt"><span>Dein Set-Vorteil (−' + pct + ' %)</span><span>−' + euro(set.ersparnis) + '</span></div>' +
      '<div class="bgf-preis__zeile bgf-preis__zeile--set"><span>Dein Geschenkset</span><strong>' + euro(set.preis) + '</strong></div>' +
    '</div>';
  }
  function stickyLeiste(set, angemeldet) {
    return '<div class="bgf-sticky" role="region" aria-label="Dein Geschenkset">' +
      '<div class="bgf-sticky__preis"><strong>' + euro(set.preis) + '</strong> <s>' + euro(set.einzeln) + '</s>' +
        '<span class="bgf-sticky__spar">Du sparst ' + euro(set.ersparnis) + '</span></div>' +
      (angemeldet
        ? '<span class="bgf-sticky__spar" style="text-align:right">Code kommt per Mail</span>'
        : '<button type="button" class="bgf-knopf bgf-knopf--klein" data-aktion="zum-formular">Preis sichern</button>') +
    '</div>';
  }
  function freischalten(set, zustand) {
    if (zustand.code) {
      return '<div class="bgf-frei bgf-frei--ok" aria-live="polite">' +
        '<p class="bgf-frei__titel">Fast geschafft: Bitte bestätige deine E-Mail</p>' +
        '<p>Wir haben dir eine Bestätigungsmail an <strong>' + esc(zustand.email) + '</strong> geschickt. ' +
        'Sobald du den Link darin anklickst, kommt dein Code für ' + euro(set.preis) + ' statt ' + euro(set.einzeln) + '.</p>' +
        '<p class="bgf-klein">In der Mail mit dem Code legt ein Klick das Set samt Rabatt in den Warenkorb. ' +
        'Keine Mail da? Schau bitte auch im Spam-Ordner nach.</p>' +
      '</div>';
    }
    return '<form class="bgf-frei" data-aktion="code" novalidate>' +
      '<p class="bgf-frei__titel">Sichere dir ' + euro(set.ersparnis) + ' Set-Vorteil</p>' +
      '<p class="bgf-klein">E-Mail eintragen und bestätigen, dann schicken wir dir deinen Code. Du zahlst ' + euro(set.preis) + ' statt ' + euro(set.einzeln) + '.</p>' +
      '<label class="bgf-feld"><span class="bgf-unsichtbar">E-Mail-Adresse</span>' +
        '<input type="email" name="email" autocomplete="email" inputmode="email" required placeholder="deine@email.de" value="' + esc(zustand.email || '') + '"></label>' +
      '<label class="bgf-falle" aria-hidden="true">Website<input type="text" name="website" tabindex="-1" autocomplete="off"></label>' +
      (zustand.fehler ? '<p class="bgf-fehler" role="alert">' + esc(zustand.fehler) + '</p>' : '') +
      '<button type="submit" class="bgf-knopf"' + (zustand.laedt ? ' disabled' : '') + '>Set für ' + euro(set.preis) + ' sichern</button>' +
      '<p class="bgf-klein">Der Code gilt 7 Tage für genau dieses Set. Mit der Anmeldung erhältst du unseren Newsletter, Abmeldung jederzeit. ' +
        '<a href="/policies/privacy-policy" target="_blank" rel="noopener">Datenschutz</a></p>' +
    '</form>';
  }
  function castellKarte(c) {
    if (!c) return '';
    return '<div class="bgf-castell">' +
      '<p class="bgf-castell__titel">Preiswerte Alternative</p>' +
      '<p>' + c.positionen.map(function (p) { return p.menge + '× ' + esc(kurztitel(p.t)) + ' · ' + esc(p.farbe); }).join(', ') + '</p>' +
      '<p><s>' + euro(c.einzeln) + '</s> <strong>' + euro(c.preis) + '</strong></p>' +
      '<button type="button" class="bgf-link" data-aktion="castell">Diese Alternative wählen</button>' +
    '</div>';
  }
  function lieferHinweis(lieferBis, bewertung) {
    var heute = new Date();
    var grenze = lieferBis ? new Date(lieferBis + 'T23:59:59') : null;
    var vorWeihnachten = grenze && heute <= grenze && heute.getMonth() >= 9
      ? '<strong>Bis ' + esc(grenze.toLocaleDateString('de-DE', { day: 'numeric', month: 'numeric' })) + ' bestellt – vor Weihnachten bei dir.</strong> '
      : '';
    var sterne = bewertung ? ' · Trusted Shops ' + esc(bewertung) + '/5' : '';
    return '<p class="bgf-liefer">' + vorWeihnachten + 'Lieferzeit 2–3 Werktage' + sterne + '</p>';
  }
  return {
    esc: esc, euro: euro, bildUrl: bildUrl, auswahlFeld: auswahlFeld, kurztitel: kurztitel, herkunft: herkunft, groesseText: groesseText,
    hinweise: hinweise, stufenWahl: stufenWahl, setKarte: setKarte, freischalten: freischalten, stickyLeiste: stickyLeiste,
    castellKarte: castellKarte, lieferHinweis: lieferHinweis
  };
}));
;
(function (root, factory) {
  if (typeof module === 'object' && module.exports) {
    module.exports = factory();
  } else {
    root.bibernaGeschenkBilder = factory();
  }
}(typeof self !== 'undefined' ? self : this, function () {
  'use strict';
  function passt(item, regel) {
    return Object.keys(regel).every(function (k) {
      return k === 'typ' ? item.typ === regel.typ : (k === 'kind' ? !!item.kind === regel.kind : item[k] === regel[k]);
    });
  }
  function bildSucher(katalog) {
    var cache = {};
    var vergeben = {};
    return function (regel) {
      if (!regel) return null;
      var key = JSON.stringify(regel);
      if (cache[key] !== undefined) return cache[key];
      var treffer = (katalog || []).filter(function (i) { return (i.szene || i.bild) && passt(i, regel); })
        .sort(function (a, b) {
          return (vergeben[a.h] ? 1 : 0) - (vergeben[b.h] ? 1 : 0) || (b.szene ? 1 : 0) - (a.szene ? 1 : 0) || b.bestand - a.bestand;
        });
      var bild = treffer.length ? (treffer[0].szene || treffer[0].bild) : null;
      if (treffer.length) vergeben[treffer[0].h] = true;
      cache[key] = bild;
      return bild;
    };
  }
  var LINIE = 'fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"';
  var KOPF = function (x, y, r) { return '<circle cx="' + x + '" cy="' + y + '" r="' + r + '"/>'; };
  var KOERPER = function (x, y, b) { return '<path d="M' + (x - b) + ' ' + (y + 14) + 'c0-' + (b * 0.9) + ' ' + (b * 0.45) + '-' + (b * 1.2) + ' ' + b + '-' + (b * 1.2) + 's' + b + ' ' + (b * 0.3) + ' ' + b + ' ' + (b * 1.2) + '"/>'; };
  var ICONS = {
    frau: KOPF(24, 15, 6) + '<path d="M18 13c0-6 12-6 12 0v6"/>' + KOERPER(24, 26, 9),
    mann: KOPF(24, 15, 6) + '<path d="M18 12c2-4 10-4 12 0"/>' + KOERPER(24, 26, 10),
    paar: KOPF(17, 15, 5) + KOPF(31, 15, 5) + KOERPER(17, 25, 7) + KOERPER(31, 25, 7),
    kind: KOPF(24, 18, 5) + KOERPER(24, 27, 7) + '<path d="M20 11l2 2M28 11l-2 2"/>',
    selbst: KOPF(24, 15, 6) + KOERPER(24, 26, 9) + '<path d="M35 9l1.5 3 3 .4-2.2 2 .6 3-2.9-1.5-2.9 1.5.6-3-2.2-2 3-.4z"/>'
  };
  function icon(name) {
    if (!ICONS[name]) return '';
    return '<svg class="bgf-icon" viewBox="0 0 48 48" width="48" height="48" aria-hidden="true" ' + LINIE + '>' + ICONS[name] + '</svg>';
  }
  return { bildSucher: bildSucher, icon: icon, _intern: { passt: passt } };
}));
;
(function () {
  'use strict';
  var ENGINE = window.bibernaGeschenkEngine;
  var S = window.bibernaGeschenkSchritte;
  var E = window.bibernaGeschenkErgebnis;
  var B = window.bibernaGeschenkBilder;
  var SPEICHER = 'bib_geschenkfinder_v1';
  function speichern(zustand) {
    try {
      localStorage.setItem(SPEICHER, JSON.stringify({ antworten: zustand.antworten, schritt: zustand.schritt }));
    } catch (e) {  }
  }
  function laden() {
    try { return JSON.parse(localStorage.getItem(SPEICHER) || 'null'); } catch (e) { return null; }
  }
  function melden(name, daten) {
    try {
      if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('geschenkfinder_' + name, daten || {});
    } catch (e) {  }
  }
  function neueAntworten() {
    return { farben: [], laken: {}, kissen: {}, _wahl: {} };
  }
  function mitGrundform(a) {
    var g = neueAntworten();
    if (!a || typeof a !== 'object') return g;
    return Object.assign({}, g, a, {
      farben: Array.isArray(a.farben) ? a.farben : [],
      laken: Object.assign({}, g.laken, a.laken),
      kissen: Object.assign({}, g.kissen, a.kissen),
      _wahl: Object.assign({}, a._wahl)
    });
  }
  var ALLGEMEIN = 'Das hat gerade nicht geklappt. Bitte versuch es gleich noch einmal.';
  function nutzerFehler(text) {
    var e = new Error(text);
    e.fuerNutzer = true;
    return e;
  }
  function fehlerText(e) {
    return e && e.fuerNutzer ? e.message : ALLGEMEIN;
  }
  function setSchluessel(set) {
    return set ? set.preis + ':' + set.positionen.map(function (p) { return p.id + 'x' + p.menge; }).join(',') : '';
  }
  function Geschenkfinder(wurzel) {
    this.el = wurzel;
    this.cfg = {
      katalogUrl: wurzel.dataset.katalogUrl,
      codeUrl: wurzel.dataset.codeUrl,
      lieferBis: wurzel.dataset.lieferBis,
      bewertung: wurzel.dataset.bewertung,
      klaviyoKey: wurzel.dataset.klaviyoKey,
      klaviyoListe: wurzel.dataset.klaviyoListe,
      startBild: wurzel.dataset.startBild
    };
    var gemerkt = laden();
    var antworten = mitGrundform(gemerkt && gemerkt.antworten);
    var vor = S.mitVorbelegung(neueAntworten(), antworten, S.vorbelegung(window.location.search));
    if (vor) melden('deeplink', { fuer: vor.antworten.fuer });
    if (window.location.search.indexOf('fuer=') > -1) {
      try {
        var url = new URL(window.location.href);
        url.searchParams.delete('fuer');
        url.searchParams.delete('alter');
        window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
      } catch (e) {  }
    }
    this.z = {
      antworten: vor ? vor.antworten : antworten,
      schritt: vor ? vor.schritt : ((gemerkt && gemerkt.schritt) || 'start'),
      stufe: null, alt: 0, castell: false,
      code: null, email: '', fehler: '', hinweis: '', laedt: false
    };
    this.stand = null;
    this.bereit = this.ladeKatalog();
    this.el.addEventListener('click', this.klick.bind(this));
    this.el.addEventListener('submit', this.absenden.bind(this));
    this.el.addEventListener('change', this.aenderung.bind(this));
    this.zeichne();
  }
  Geschenkfinder.prototype.ladeKatalog = function (frisch) {
    var self = this;
    return fetch(this.cfg.katalogUrl, { credentials: 'omit', cache: frisch ? 'reload' : 'default' })
      .then(function (r) { if (!r.ok) throw new Error('Katalog ' + r.status); return r.json(); })
      .then(function (stand) {
        self.stand = stand;
        self._schnell = null;
        self._cacheKey = null;
        self.bild = B.bildSucher(stand.katalog);
        self.nachId = {};
        stand.katalog.forEach(function (i) { self.nachId[i.id] = i; });
        self.zeichne();
      })
      .catch(function () {
        if (!frisch) return self.ladeKatalog(true);
        self.stand = { fehler: true };
        self.zeichne();
        return undefined;
      });
  };
  Geschenkfinder.prototype.setze = function (teil) {
    this.z = Object.assign({}, this.z, teil);
    speichern(this.z);
    this.zeichne();
  };
  Geschenkfinder.prototype.antworte = function (aenderung) {
    var a = Object.assign({}, this.z.antworten, aenderung);
    this.setze({ antworten: a, stufe: null, alt: 0, code: null, fehler: '', hinweis: '', castell: false });
  };
  Geschenkfinder.prototype.schrittListe = function () {
    return S.aktiveSchritte(this.z.antworten);
  };
  Geschenkfinder.prototype.weiter = function () {
    var liste = this.schrittListe();
    var idx = liste.map(function (s) { return s.id; }).indexOf(this.z.schritt);
    var naechster = idx < 0 ? liste[0] : liste[idx + 1];
    melden('schritt', { von: this.z.schritt, nach: naechster ? naechster.id : 'ergebnis' });
    this.setze({ schritt: naechster ? naechster.id : 'ergebnis' });
    this.el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  Geschenkfinder.prototype.zurueck = function () {
    var liste = this.schrittListe();
    var ids = liste.map(function (s) { return s.id; });
    var idx = this.z.schritt === 'ergebnis' ? ids.length : ids.indexOf(this.z.schritt);
    this.setze({ schritt: idx <= 0 ? 'start' : ids[idx - 1] });
  };
  Geschenkfinder.prototype.klick = function (ev) {
    var t = ev.target.closest('[data-aktion], [data-feld], [data-stufe]');
    if (!t || !this.el.contains(t)) return;
    if (this.z.laedt) return;
    var a = this.z.antworten;
    if (t.dataset.feld) return this.waehle(t.dataset.feld, t.dataset.wert, t.dataset.schluessel);
    if (t.dataset.stufe) return this.setze({ stufe: t.dataset.stufe, code: null, castell: false, hinweis: '' });
    switch (t.dataset.aktion) {
      case 'start': return this.setze({ schritt: this.schrittListe()[0].id });
      case 'neu': return this.setze({ antworten: neueAntworten(), schritt: 'fuer', stufe: null, alt: 0, code: null, castell: false, fehler: '' });
      case 'zurueck': return this.zurueck();
      case 'weiter': return this.weiter();
      case 'ergebnis': melden('abkuerzung', { von: this.z.schritt }); return this.setze({ schritt: 'ergebnis' });
      case 'zum-formular': return this.zumFormular();
      case 'schnell': return this.schnellweg(t.dataset.id);
      case 'farbe': return this.farbe(t.dataset.wert);
      case 'alt': return this.setze({ alt: this.z.alt + Number(t.dataset.richtung), code: null, fehler: '' });
      case 'castell': return this.setze({ castell: true, code: null });
      case 'einzeln': return this.inDenWarenkorb();
      default: return undefined;
    }
  };
  Geschenkfinder.prototype.waehle = function (feld, wert, schluessel) {
    var a = this.z.antworten;
    var wahl = Object.assign({}, a._wahl, { [feld]: schluessel || wert });
    var aenderung = { _wahl: wahl };
    if (feld === 'fuer' && wert !== a.fuer) {
      aenderung = Object.assign(neueAntworten(), { fuer: wert, _wahl: { fuer: wert } });
    } else if (feld === 'matratze') {
      aenderung.laken = Object.assign({}, a.laken, { matratze: wert || null });
    } else {
      aenderung[feld] = wert;
    }
    this.antworte(aenderung);
    var schritt = this.schrittListe().filter(function (s) { return s.id === this.z.schritt; }, this)[0];
    if (schritt && !schritt.farben && S.fertig(schritt, this.z.antworten) && S.felderVon(schritt, this.z.antworten).length === 1) {
      this.weiter();
    }
  };
  Geschenkfinder.prototype.zumFormular = function () {
    var feld = this.el.querySelector('form[data-aktion="code"] input[name="email"]');
    if (!feld) return;
    feld.scrollIntoView({ behavior: 'smooth', block: 'center' });
    feld.focus({ preventScroll: true });
  };
  Geschenkfinder.prototype.groessenWahl = function (set) {
    var a = this.z.antworten;
    var wahl = {};
    if (a.fuer === 'kind') {
      wahl.garnitur = { feld: 'kindAlter', aktuell: a.kindAlter, optionen: [
        { wert: 'klein', titel: 'Kleinkind · 100 × 135 cm' }, { wert: 'schul', titel: 'Schulkind · 135 × 200 cm' }] };
    } else if (!(a.fuer === 'paar' && a.paarDecken === 'eine')) {
      wahl.garnitur = { feld: 'decke', aktuell: a.decke || '135x200', optionen: [
        { wert: '135x200', titel: 'Decke 135 × 200 cm' }, { wert: '155x200', titel: 'Decke 155 × 200 cm' }, { wert: '155x220', titel: 'Decke 155 × 220 cm' }] };
    }
    if (a.laken.matratze && !(a.fuer === 'kind' && a.kindAlter === 'klein')) {
      wahl.laken = { feld: 'matratze', aktuell: a.laken.matratze, optionen: S.MATRATZEN.filter(function (m) { return m.wert; })
        .map(function (m) { return { wert: m.wert, titel: 'Matratze ' + m.titel + ' cm' }; }) };
      var garnitur = set && this.nachId[set.positionen[0].id];
      var imSet = set && set.positionen.filter(function (p) { return p.typ === 'laken'; })[0];
      var qualitaeten = garnitur ? ENGINE.lakenAuswahl(this.stand.katalog, garnitur, a, this.stand.regeln) : [];
      wahl.laken.qualitaet = { aktuell: imSet ? (this.nachId[imSet.id] || {}).serie : a.laken.serie,
        optionen: qualitaeten.map(function (q) { return { wert: q.serie, titel: E.kurztitel(q.titel) }; }) };
    }
    var garniturImSet = set && this.nachId[set.positionen[0].id];
    var farben = garniturImSet ? ENGINE.farbAuswahl(this.stand.katalog, garniturImSet, this.stand.regeln) : [];
    if (farben.length > 1) {
      wahl.garnitur = Object.assign({}, wahl.garnitur || { optionen: [] }, { farbe: { aktuell: String(garniturImSet.id),
        optionen: farben.map(function (f) { return { wert: String(f.id), titel: 'Farbe: ' + f.farbe }; }) } });
    }
    var kissenImSet = set && set.positionen.filter(function (p) { return p.typ === 'kissen'; })[0];
    if (kissenImSet) {
      var garniturFuerKissen = this.nachId[set.positionen[0].id];
      wahl.kissen = { feld: 'kissen', aktuell: ENGINE._intern.kissenGroesse(garniturFuerKissen || {}, a), optionen: S.KISSEN.map(function (k) { return { wert: k.wert, titel: 'Kissen ' + k.titel + ' cm' }; }) };
    }
    return wahl;
  };
  Geschenkfinder.prototype.aenderung = function (ev) {
    var d = (ev.target && ev.target.dataset) || {};
    if (this.z.laedt) return;
    if (d.groesse) return this.groesseTauschen(d.groesse, ev.target.value);
    if (d.farbe === 'garnitur') return this.farbeTauschen(Number(ev.target.value));
    if (d.qualitaet === 'laken') {
      var a = this.z.antworten;
      return this.neuBerechnen(Object.assign({}, a, { laken: Object.assign({}, a.laken, { serie: ev.target.value }) }), 'qualitaet');
    }
    return undefined;
  };
  Geschenkfinder.prototype.groesseTauschen = function (typ, wert) {
    var a = this.z.antworten;
    var neu;
    if (typ === 'garnitur') {
      var feld = a.fuer === 'kind' ? 'kindAlter' : 'decke';
      neu = Object.assign({}, a, { [feld]: wert, _wahl: Object.assign({}, a._wahl, { [feld]: wert }) });
    } else if (typ === 'laken') {
      neu = Object.assign({}, a, { laken: Object.assign({}, a.laken, { matratze: wert || null }), _wahl: Object.assign({}, a._wahl, { matratze: wert || 'unbekannt' }) });
    } else if (typ === 'kissen') {
      neu = Object.assign({}, a, { kissen: Object.assign({}, a.kissen, { groesse: wert }) });
    } else {
      return;
    }
    this.neuBerechnen(neu, typ);
  };
  Geschenkfinder.prototype.farbeTauschen = function (id) {
    var g = this.nachId[id];
    if (!g) return;
    var a = this.z.antworten;
    var farbwahl = Object.assign({}, a.farbwahl);
    farbwahl[g.h] = id;
    this.neuBerechnen(Object.assign({}, a, { farbwahl: farbwahl }), 'farbe');
  };
  Geschenkfinder.prototype.neuBerechnen = function (neu, typ) {
    var vorher = this.aktuellesSet(this.angebot());
    var ang = ENGINE.angebot(this.stand.katalog, neu, this.stand.regeln, this.stand.farbErsatz);
    if (ang.leer) {
      return this.setze({ hinweis: 'Damit gibt es gerade kein passendes Set. Wir haben dein bisheriges Set behalten.' });
    }
    melden('tausch', { typ: typ });
    this.setze({ antworten: neu, code: null, castell: false, fehler: '' });
    var nachher = this.aktuellesSet(this.angebot());
    this.setze({ hinweis: nachher && vorher && nachher.preis !== vorher.preis
      ? 'Mit deiner Änderung kostet das Set ' + E.euro(nachher.preis) + ' statt ' + E.euro(vorher.preis) + '.' : '' });
  };
  Geschenkfinder.prototype.farbe = function (wert) {
    var farben = this.z.antworten.farben || [];
    var neu = !wert ? [] : (farben.indexOf(wert) > -1
      ? farben.filter(function (f) { return f !== wert; })
      : farben.concat(wert).slice(-2));
    this.antworte({ farben: neu });
    if (!wert) this.weiter();
  };
  Geschenkfinder.prototype.schnellweg = function (id) {
    var p = ((this.stand && this.stand.regeln && this.stand.regeln.schnellweg) || []).filter(function (s) { return s.id === id; })[0];
    if (!p) return;
    melden('schnellweg', { id: id });
    this.setze({ antworten: mitGrundform(p.antworten), schritt: 'ergebnis', stufe: null, alt: 0, code: null, castell: false, fehler: '' });
  };
  Geschenkfinder.prototype.angebot = function () {
    if (!this.stand || !this.stand.katalog) return null;
    var key = JSON.stringify(this.z.antworten);
    if (this._cacheKey !== key) {
      this._cacheKey = key;
      this._cache = ENGINE.angebot(this.stand.katalog, this.z.antworten, this.stand.regeln, this.stand.farbErsatz);
    }
    return this._cache;
  };
  Geschenkfinder.prototype.design = function (ang) {
    var n = ang.designs.length;
    return ang.designs[((this.z.alt % n) + n) % n];
  };
  Geschenkfinder.prototype.aktuellesSet = function (ang) {
    if (!ang || ang.leer) return null;
    if (this.z.castell && ang.castell) return ang.castell;
    var stufen = this.design(ang).stufen;
    var finde = function (id) { return stufen.filter(function (s) { return s.stufe === id; })[0]; };
    return finde(this.z.stufe) || finde('laken') || stufen[0];
  };
  Geschenkfinder.prototype.absenden = function (ev) {
    if (!ev.target.matches('form[data-aktion="code"]')) return;
    ev.preventDefault();
    if (this.z.laedt) return; // Enter doppelt gedrueckt: nur ein Code
    var self = this;
    var form = ev.target;
    var email = form.email.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      return this.setze({ email: email, fehler: 'Bitte gib eine gültige E-Mail-Adresse ein.' });
    }
    var ang = this.angebot();
    var set = this.aktuellesSet(ang);
    var schluessel = setSchluessel(set);
    this.setze({ email: email, laedt: true, fehler: '' });
    melden('email', { preis: set.preis });
    fetch(this.cfg.codeUrl, {
      method: 'POST', credentials: 'omit', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email: email, website: form.website.value,
        antworten: this.z.antworten,
        set: { preis: set.preis, positionen: set.positionen.map(function (p) { return { id: p.id, menge: p.menge }; }) }
      })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (j) { return { status: r.status, ok: r.ok, j: j }; });
      })
      .then(function (res) {
        if (res.status === 409) self.ladeKatalog(true);
        if (!res.ok || !res.j.bestaetigen) throw nutzerFehler(res.j.fehler || 'Der Code konnte gerade nicht erstellt werden.');
        if (setSchluessel(self.aktuellesSet(self.angebot())) !== schluessel) {
          throw nutzerFehler('Dein Set hat sich geändert. Bitte noch einmal auf „sichern“ tippen.');
        }
        self.setze({ code: res.j, laedt: false });
        melden('code', { preis: set.preis });
      })
      .catch(function (e) {
        self.setze({ laedt: false, fehler: fehlerText(e) });
      });
  };
  Geschenkfinder.prototype.inDenWarenkorb = function () {
    var self = this;
    var ang = this.angebot();
    var set = this.aktuellesSet(ang);
    this.setze({ laedt: true, fehler: '' });
    var handles = set.positionen.map(function (p) { return p.h; }).filter(function (h, i, l) { return l.indexOf(h) === i; });
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) {
        if (!r.ok) throw nutzerFehler('Ein Teil dieses Sets ist gerade nicht verfügbar. Bitte wähle ein anderes Design.');
        return r.json();
      });
    }))
      .then(function (produkte) {
        var lieferbar = {};
        produkte.forEach(function (p) { p.variants.forEach(function (v) { lieferbar[v.id] = v.available; }); });
        var fehlt = set.positionen.filter(function (p) { return !lieferbar[p.id]; });
        if (fehlt.length) throw nutzerFehler('Ein Teil dieses Sets ist gerade ausverkauft. Bitte wähle ein anderes Design.');
        return fetch('/cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: set.positionen.map(function (p) {
            return { id: p.id, quantity: p.menge };
          }) })
        });
      })
      .then(function (r) {
        if (!r.ok) throw nutzerFehler('Das Set konnte nicht in den Warenkorb gelegt werden.');
        melden('warenkorb', { preis: set.preis, mitCode: false });
        window.location.href = '/cart';
      })
      .catch(function (e) { self.setze({ laedt: false, fehler: fehlerText(e) }); });
  };
  Geschenkfinder.prototype.zeichne = function () {
    var z = this.z;
    var html;
    if (this.stand && this.stand.fehler) {
      html = '<div class="bgf-karte"><p>Der Geschenkfinder ist gerade nicht erreichbar.</p><a class="bgf-knopf" href="/collections/bettwasche">Zur Bettwäsche</a></div>';
    } else if (z.schritt === 'start') {
      html = this.zeichneStart();
    } else if (z.schritt === 'ergebnis') {
      html = this.stand ? this.zeichneErgebnis() : '<div class="bgf-karte bgf-laedt">Dein Set wird zusammengestellt …</div>';
    } else {
      html = this.zeichneSchritt();
    }
    this.el.querySelector('[data-bgf-buehne]').innerHTML = html;
  };
  Geschenkfinder.prototype.zeichneStart = function () {
    var self = this;
    if (!this._schnell && this.stand && this.stand.katalog) {
      this._schnell = ((this.stand.regeln && this.stand.regeln.schnellweg) || []).map(function (p) {
        var ang = ENGINE.angebot(self.stand.katalog, mitGrundform(p.antworten), self.stand.regeln, self.stand.farbErsatz);
        if (ang.leer) return '';
        var ab = Math.min.apply(null, ang.designs[0].stufen.map(function (st) { return st.preis; }));
        return '<button type="button" class="bgf-schnell" data-aktion="schnell" data-id="' + E.esc(p.id) + '">' +
          '<span>' + E.esc(p.titel) + '</span><span class="bgf-klein">ab ' + E.euro(ab) + '</span></button>';
      }).join('');
    }
    var schnell = this._schnell || '';
    var heldBild = this.cfg.startBild || (this.bild && this.bild({ typ: 'garnitur', kind: false, gefuehl: 'warm' }));
    return '<div class="bgf-start">' +
      (heldBild ? '<div class="bgf-held"><img src="' + E.esc(E.bildUrl(heldBild, 1200)) + '" alt="" width="1200" height="800">' +
        '<span class="bgf-held__band">Geschenkset · bis zu 26 % Set-Vorteil</span></div>' : '') +
      '<p class="bgf-eyebrow">Geschenkfinder</p>' +
      '<h2 class="bgf-h">Das schönste Geschenk für gute Nächte</h2>' +
      '<p>Zwei Fragen genügen, drei weitere machen es persönlich. Dauert etwa eine Minute.</p>' +
      '<button type="button" class="bgf-knopf" data-aktion="start">Jetzt Geschenk finden</button>' +
      (schnell ? '<p class="bgf-zwischen">Keine Zeit? Unsere beliebtesten Geschenksets:</p><div class="bgf-schnellwahl">' + schnell + '</div>' : '') +
      '<p class="bgf-vertrauen">Familienunternehmen seit 1932 · STANDARD 100 by OEKO-TEX®</p>' +
    '</div>';
  };
  Geschenkfinder.prototype.kopf = function () {
    var liste = this.schrittListe();
    var idx = liste.map(function (s) { return s.id; }).indexOf(this.z.schritt);
    var rest = liste.length - idx - 1;
    var pillen = liste.map(function (s, i) {
      var zustand = i < idx ? ' is-fertig' : (i === idx ? ' is-aktiv' : '');
      return '<li class="bgf-leiste__schritt' + zustand + '"><span class="bgf-leiste__nr">' + (i < idx ? '✓' : i + 1) + '</span>' +
        '<span class="bgf-leiste__name">' + E.esc(s.kurz) + (s.optional ? ' <small>optional</small>' : '') + '</span></li>';
    }).join('');
    var abkuerzung = S.pflichtFertig(this.z.antworten) && liste[idx] && (liste[idx].optional || rest === 0)
      ? '<button type="button" class="bgf-link bgf-link--abk" data-aktion="ergebnis">Direkt zum Ergebnis →</button>' : '';
    return '<div class="bgf-kopf">' +
      '<button type="button" class="bgf-zurueck" data-aktion="zurueck" aria-label="Zurück">←</button>' +
      '<span class="bgf-klein">Frage ' + (idx + 1) + ' von ' + liste.length + ' · ' + (rest ? 'noch ' + rest + (rest === 1 ? ' Frage' : ' Fragen') : 'letzte Frage') + '</span>' +
      abkuerzung + '</div>' +
      '<ol class="bgf-leiste" aria-label="Fortschritt">' + pillen + '</ol>';
  };
  Geschenkfinder.prototype.optionen = function (feld, optionen, gewaehlt) {
    var self = this;
    var mitBild = optionen.some(function (o) { return o.bild && self.bild && self.bild(o.bild); });
    return '<div class="bgf-optionen' + (mitBild ? ' bgf-optionen--bild' : '') + '">' + optionen.map(function (o) {
      var key = o.schluessel || o.wert;
      var an = gewaehlt === key;
      var foto = o.bild && self.bild ? self.bild(o.bild) : null;
      var kopf = foto
        ? '<span class="bgf-option__bild"><img src="' + E.esc(E.bildUrl(foto, 400)) + '" alt="" width="400" height="300" loading="lazy"></span>'
        : (o.icon && B ? B.icon(o.icon) : '');
      return '<button type="button" class="bgf-option' + (an ? ' is-aktiv' : '') + (foto ? ' bgf-option--bild' : '') + '" aria-pressed="' + an + '" data-feld="' + feld + '" data-wert="' + E.esc(o.wert) + '"' +
        (o.schluessel ? ' data-schluessel="' + E.esc(o.schluessel) + '"' : '') + '>' + kopf +
        '<span class="bgf-option__titel">' + E.esc(o.titel) + '</span>' +
        (o.text ? '<span class="bgf-option__text">' + E.esc(o.text) + '</span>' : '') + '</button>';
    }).join('') + '</div>';
  };
  Geschenkfinder.prototype.zeichneSchritt = function () {
    var self = this;
    var a = this.z.antworten;
    var schritt = this.schrittListe().filter(function (s) { return s.id === self.z.schritt; })[0];
    if (!schritt) return this.zeichneStart();
    var inhalt;
    if (schritt.farben) inhalt = this.zeichneFarben();
    else {
      inhalt = S.felderVon(schritt, a).map(function (f) {
        return (f.titel ? '<p class="bgf-unterfrage">' + E.esc(f.titel) + '</p>' : '') + self.optionen(f.name, f.optionen, a._wahl[f.name]);
      }).join('');
    }
    var mehrfeldrig = schritt.farben || S.felderVon(schritt, a).length > 1;
    return this.kopf() +
      '<h2 class="bgf-h">' + E.esc(schritt.frage) + '</h2>' +
      (schritt.hinweis ? '<p class="bgf-klein">' + E.esc(schritt.hinweis) + '</p>' : '') +
      inhalt +
      (mehrfeldrig ? '<button type="button" class="bgf-knopf" data-aktion="weiter"' + (S.fertig(schritt, a) ? '' : ' disabled') + '>Weiter</button>' : '');
  };
  Geschenkfinder.prototype.zeichneFarben = function () {
    var farben = this.z.antworten.farben || [];
    return '<div class="bgf-farben">' + S.FARBEN.map(function (f) {
      var an = farben.indexOf(f.wert) > -1;
      return '<button type="button" class="bgf-farbe' + (an ? ' is-aktiv' : '') + '" aria-pressed="' + an + '" data-aktion="farbe" data-wert="' + f.wert + '">' +
        '<span class="bgf-farbe__toene">' + f.toene.map(function (t) { return '<i style="background:' + t + '"></i>'; }).join('') + '</span>' +
        '<span>' + E.esc(f.titel) + '</span></button>';
    }).join('') + '</div><button type="button" class="bgf-link" data-aktion="farbe" data-wert="">Überrasch mich</button>';
  };
  Geschenkfinder.prototype.zeichneErgebnis = function () {
    var ang = this.angebot();
    if (!ang || ang.leer) {
      return '<div class="bgf-karte"><h2 class="bgf-h">Dafür finden wir gerade kein Set</h2>' +
        '<p>Mit diesen Wünschen ist gerade nichts passend lieferbar. Probier eine andere Größe oder lass das Spannbetttuch weg.</p>' +
        '<button type="button" class="bgf-knopf" data-aktion="neu">Neu starten</button></div>';
    }
    var set = this.aktuellesSet(ang);
    var design = this.design(ang);
    var altAnzahl = this.z.castell ? 1 : ang.designs.length;
    var altIndex = ((this.z.alt % ang.designs.length) + ang.designs.length) % ang.designs.length;
    var ohneMatratze = !this.z.antworten.laken.matratze && !(this.z.antworten.fuer === 'kind' && this.z.antworten.kindAlter === 'klein');
    return '<div class="bgf-ergebnis">' +
      '<button type="button" class="bgf-zurueck" data-aktion="zurueck" aria-label="Antworten ändern">← Antworten ändern</button>' +
      '<h2 class="bgf-h">Dein Geschenkset ist fertig</h2>' +
      E.hinweise(ang.gelockert) +
      (this.z.castell ? '' : E.stufenWahl(design.stufen, set.stufe)) +
      (ohneMatratze && !this.z.castell ? '<p class="bgf-hinweis">Mit Matratzengröße gibt es das Set auch mit passendem Spannbetttuch: ' +
        E.auswahlFeld('data-groesse', 'laken', { optionen: [{ wert: '', titel: 'Matratze wählen …' }].concat(S.MATRATZEN.filter(function (m) { return m.wert; })
          .map(function (m) { return { wert: m.wert, titel: m.titel + ' cm' }; })), aktuell: '' }, 'Matratzengröße') + '</p>' : '') +
      (this.z.hinweis ? '<p class="bgf-hinweis" role="status">' + E.esc(this.z.hinweis) + '</p>' : '') +
      '<div class="bgf-raster">' +
        E.setKarte(set, this.nachId, altIndex, altAnzahl, this.z.castell ? null : this.groessenWahl(set)) +
        '<div class="bgf-seite">' +
          E.freischalten(set, this.z) +
          (this.z.code ? '' : '<button type="button" class="bgf-link" data-aktion="einzeln"' + (this.z.laedt ? ' disabled' : '') + '>Ohne Rabatt einzeln in den Warenkorb – ' + E.euro(set.einzeln) + '</button>') +
          (this.z.fehler && this.z.code ? '<p class="bgf-fehler" role="alert">' + E.esc(this.z.fehler) + '</p>' : '') +
          (!this.z.castell && ang.castell && set.stufe !== 'komplett' ? E.castellKarte(ang.castell) : '') +
          E.lieferHinweis(this.cfg.lieferBis, this.cfg.bewertung) +
        '</div>' +
      '</div>' +
      '<button type="button" class="bgf-link" data-aktion="neu">Neues Geschenk zusammenstellen</button>' +
      E.stickyLeiste(set, this.z.code) +
    '</div>';
  };
  function start() {
    var el = document.querySelector('[data-bgf]');
    if (el && ENGINE && S && E && B) {
      el.geschenkfinder = new Geschenkfinder(el);
      melden('geladen', {});
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
}());
